import { useQuery } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import type { EventId } from "@/types/identifiers";

export function useTeamReport(eventId: EventId, team?: string) {
  return useQuery({
    queryKey: ["team-report", eventId, team],
    queryFn: async () => {
      const result = await api.GET("/api/team-report/{event_id}", {
        params: {
          path: { event_id: eventId },
          query: team ? { team } : undefined,
        },
      });
      return throwIfError(result, "Failed to fetch team report");
    },
  });
}

export function useTeams(enabled = true) {
  return useQuery({
    queryKey: ["teams"],
    queryFn: async () => {
      const result = await api.GET("/api/teams");
      return throwIfError(result, "Failed to fetch teams");
    },
    enabled,
  });
}
